import React, { useEffect, useState } from "react";
import { useLang } from "@/context/LangContext";
import api, { API_BASE } from "@/lib/api";
import { Newspaper, Download } from "lucide-react";
import { format, parseISO } from "date-fns";

export default function NewsSection() {
  const { t, lang } = useLang();
  const [items, setItems] = useState([]);

  useEffect(() => { (async () => {
    try { const { data } = await api.get(`/news?limit=12`); setItems(data); } catch(e){}
  })(); }, []);

  if (items.length === 0) return null;

  return (
    <section id="news" data-testid="news-section" className="max-w-7xl mx-auto px-6 md:px-10 py-24 md:py-32 border-t border-[hsl(var(--border))]">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
        <div>
          <p className="text-xs tracking-[0.25em] text-[hsl(var(--muted-foreground))]">{t.news.eyebrow}</p>
          <h2 className="font-display text-3xl md:text-5xl tracking-tight font-medium mt-3">{t.news.title}</h2>
        </div>
        <p className="text-sm text-[hsl(var(--muted-foreground))] max-w-md">{t.news.sub}</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="news-list">
        {items.map((n) => (
          <article key={n.id} data-testid={`news-${n.id}`} className="group rounded-2xl border border-[hsl(var(--border))] bg-white p-6 lift flex flex-col">
            <div className="flex items-center gap-2 text-xs tracking-[0.25em] uppercase text-[hsl(var(--primary))]">
              <Newspaper className="w-3.5 h-3.5" />
              {n.issue_no ? `${t.news.issue} ${n.issue_no}` : t.news.issue_generic}
            </div>
            <h3 className="font-display text-xl tracking-tight font-medium mt-3">
              {lang === "zh" && n.title_zh ? n.title_zh : n.title}
            </h3>
            <p className="mt-2 text-xs text-[hsl(var(--muted-foreground))]">
              {format(parseISO(n.published_at), "MMMM dd, yyyy")}
            </p>
            <div className="flex-1" />
            <a
              href={`${API_BASE}/news/${n.id}/download`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`news-download-${n.id}`}
              className="mt-5 inline-flex items-center justify-center gap-2 text-sm px-4 py-2 rounded-full bg-[hsl(var(--foreground))] text-[hsl(var(--background))] hover:bg-[hsl(var(--foreground))]/90 transition-colors"
            >
              <Download className="w-3.5 h-3.5" />{t.news.read_pdf}
            </a>
          </article>
        ))}
      </div>
    </section>
  );
}
